<template>
  <div class="embed-instagram" v-if="show">
      <div class="instagram-wrapper-iframe" v-html="html"></div>   
  </div>
</template>

<script>
export default {
  name: "embed_instagram",
  props: {
    content: Object
  },
  data: () => ({
    show: false,
    url: '',
    html: '',
    // height: 0 
  }),
  created() {
    this.url = this.content.instagram;
    if (this.url) {
      // add embed to the end
      var lastChar = this.url.substr(-1); 
      if (lastChar != '/') {
        this.url = this.url.concat('/embed');
      }else{
        this.url = this.url.concat('embed');
      }
      // console.log(this.url);
      //prepare html
      this.html = '<iframe src="' + this.url + '" allowtransparency="true" scrolling="no" allowfullscreen="false"></iframe>';
      this.show=true;
    }    
  } 
  // mounted(){
  //   var test = this.$refs.iframe;
  //   console.log(test);
  // } 
};
</script>

<style lang="scss">
.embed-instagram {
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 10%;
    width: calc(90% - 500px);
    height: 100%;
    background: rgba(184, 184, 184, 0.2);
  }
  .instagram-wrapper-iframe {
    position: relative;
    margin-left: calc(100% - 500px - 100px);
    z-index: 2;
    background-color: white;
    box-shadow:0 0 1px 0 rgba(0,0,0,0.5);
    width: 500px;
    height: 832px; 
    overflow: hidden;
    margin-top: 100px;
    // margin-bottom: 100px;
    iframe{
      background:#FFF;
      padding:0; 
      width: 100%;
      height:100%;
    }
  }
}
@media (max-width: $desktop) {
  .embed-instagram {
    .instagram-wrapper-iframe {
      margin-top: 100px;
      margin-bottom: 100px;
    }
  }
}
@media (max-width: $tablet) {
  .embed-instagram {
    &:before {
      display: none;
    }
    .instagram-wrapper-iframe {
      margin-left: 0;
      width: 400px;
      height: 707px;
      margin-top: 50px;
      margin-bottom: 50px;
    }
  }
}
@media (max-width: $mobile) {
  .embed-instagram {
    .instagram-wrapper-iframe {
      text-align: center;
      width: 90vw;
      height: calc(1.25 * 90vw + 210px);
      margin-left: 5%;
      // margin-bottom: 50px;
      // margin-top: 50px;
    }
  }
}

</style>